// extracted by mini-css-extract-plugin
export var aircallIframe = "_gr-3";
export var fabContainer = "_gr-5";
export var fabRinging = "_gr-6";
export var loadingOverlay = "_gr-4";
export var pulse = "_gr-7";
export var widgetContent = "_gr-2";
export var widgetPanel = "_gr-0";
export var widgetPanelExpanded = "_gr-1";